var _SelectManyEnumerator_currentSetEnumerator, _SelectManyEnumerator_enumerator, _SelectManyEnumerator_selector, _SelectManyEnumerator_currentItem;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import EnumeratorBase from "./EnumeratorBase";
import Exception from '../Exceptions/Exception';
export default class SelectManyEnumerator extends EnumeratorBase {
    constructor(enumerator, selector) {
        super();
        _SelectManyEnumerator_currentSetEnumerator.set(this, void 0);
        _SelectManyEnumerator_enumerator.set(this, void 0);
        _SelectManyEnumerator_selector.set(this, void 0);
        _SelectManyEnumerator_currentItem.set(this, void 0);
        __classPrivateFieldSet(this, _SelectManyEnumerator_enumerator, enumerator, "f");
        __classPrivateFieldSet(this, _SelectManyEnumerator_selector, selector, "f");
    }
    get current() {
        if (__classPrivateFieldGet(this, _SelectManyEnumerator_currentItem, "f") === undefined) {
            throw new Exception("Current is undefined");
        }
        return __classPrivateFieldGet(this, _SelectManyEnumerator_currentItem, "f");
    }
    moveNext() {
        __classPrivateFieldSet(this, _SelectManyEnumerator_currentItem, this.peek(), "f");
        if (__classPrivateFieldGet(this, _SelectManyEnumerator_currentItem, "f") === undefined) {
            return false;
        }
        return __classPrivateFieldGet(this, _SelectManyEnumerator_enumerator, "f").moveNext();
    }
    peek() {
        const item = __classPrivateFieldGet(this, _SelectManyEnumerator_enumerator, "f").peek();
        if (item === undefined) {
            return;
        }
        if (!__classPrivateFieldGet(this, _SelectManyEnumerator_currentSetEnumerator, "f")) {
            __classPrivateFieldSet(this, _SelectManyEnumerator_currentSetEnumerator, __classPrivateFieldGet(this, _SelectManyEnumerator_selector, "f").call(this, item).getEnumerator(), "f");
        }
        if (__classPrivateFieldGet(this, _SelectManyEnumerator_currentSetEnumerator, "f").moveNext()) {
            //
        }
    }
    reset() {
        __classPrivateFieldGet(this, _SelectManyEnumerator_enumerator, "f").reset();
    }
}
_SelectManyEnumerator_currentSetEnumerator = new WeakMap(), _SelectManyEnumerator_enumerator = new WeakMap(), _SelectManyEnumerator_selector = new WeakMap(), _SelectManyEnumerator_currentItem = new WeakMap();
